export default __webpack_public_path__ + "static/media/PaymentSucess.fb04c6d0.png";